// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blue-check{margin-left:auto;display:flex;align-items:center;justify-content:center;background-color:#104182;border-radius:100%;width:30px;height:30px}.blue-check>*{max-width:50%}.blue-check--small{width:24px;height:24px}\n", ""]);
// Exports
module.exports = exports;
